import { render, staticRenderFns } from "./HomeUser.vue?vue&type=template&id=009604a0"
import script from "./HomeUser.vue?vue&type=script&lang=js"
export * from "./HomeUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports